import React from "react";
import { css } from "@emotion/css";

const containerStyles = css`
  position: relative;
  width: 100%;
  height: 100%;
`;

const overlayStyles = css`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  transition: 0.5s ease;
  opacity: 0;
  background: rgba(0, 0, 0, 0.5);

  &:hover {
    opacity: 1;
  }
`;

const iconContainerStyles = css`
  position: absolute;
  margin-left: auto;
  top: 0;
  right: 0;
  padding: 8px;
`;

const hoverTextContainerStyles = css`
  position: absolute;
  margin: auto;
  left: 0;
  right: 0;
  top: 50px;
  text-align: center;
`;

type HoverOverlayProps = React.PropsWithChildren<{
  onClick?: () => void;
  hoverText?: string;
  hoverIcon?: React.ReactNode;
  disabled?: boolean;
}>;

function HoverOverlay(props: HoverOverlayProps) {
  const { disabled, children, onClick, hoverIcon, hoverText } = props;

  if (disabled) {
    return <div className={containerStyles}>{children}</div>;
  }

  return (
    <div className={containerStyles} onClick={onClick}>
      {children}
      <div className={overlayStyles}>
        <div className={hoverTextContainerStyles}>
          <h2>{hoverText}</h2>
        </div>
        <div className={iconContainerStyles}>{hoverIcon}</div>
      </div>
    </div>
  );
}

export default HoverOverlay;
